import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { postCancelUserOrder } from "../requests/UserOrders";
import { useQueryUserOrdersPending } from "services/api/queries/useQueryUserOrdersPending";
import { useQueryUserOrdersFinished } from "services/api/queries/useQueryUserOrdersFinished";
import { ICardapioAppState } from "../../../redux/RootReducer";


export function useMutationCancelUserOrder() {
    const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
    const { refetch: refetchPedingOrders } = useQueryUserOrdersPending(loginInfo?.id ?? -1)
    const { refetch: refetchFinishedOrders } = useQueryUserOrdersPending(loginInfo?.id ?? -1)


    const query = useMutation(postCancelUserOrder, {
        onSuccess: async (data) => {
            if(data?.success) {
                // console.log(data?.data)
                //apiShoppingBag.refetch();
                await refetchPedingOrders()
                await refetchFinishedOrders()
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            console.error(data)
        }
    });
    return query;
}